<template>
  <el-dialog title="社保政策库" :visible.sync="socialInsuranceDialogVisible" :width="width" append-to-body
    :close-on-click-modal="false" @close="handleClose">
    <div class="search-container">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="参保地：">
          <Area v-model="searchForm.cityCode" width="240px" :type="2" style="width: 200px;" placeholder="请选择参保地"
            :show-all-levels="false" @change="handleSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" style="width: 100%" :loading="loading" @row-click="handleRowClick">
      <el-table-column prop="cityName" label="参保地" min-width="100px"></el-table-column>
      <el-table-column prop="areaPolicy" label="地区政策" min-width="120px"></el-table-column>
      <el-table-column prop="welfareName" label="险种" min-width="300px" />
      <el-table-column prop="publishTime" label="发布时间" min-width="150px"></el-table-column>
      <el-table-column label="操作" min-width="80px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click.stop="handleViewDetail(row)" class="view-btn">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination background layout="prev, pager, next, jumper, sizes, total" :total="total" :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]" @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
    </div>

    <!-- 详情弹窗 -->
    <standard-settings-detail :visible.sync="detailDialog" :id="id" :type="type" />
  </el-dialog>
</template>

<script>
import StandardSettingsDetail from "./StandardSettingsDetail.vue";
import socialInsurancePolicyApi from '@/api/employee/socailInsurancePolicy'

export default {
  name: 'SocialInsuranceStandard',
  components: { StandardSettingsDetail },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '80%'
    }
  },
  data() {
    return {
      socialInsuranceDialogVisible: false,
      searchForm: {
        cityCode: [],
      },
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      loading: false,
      detailDialog: false,
      id: null,
      type: 'publishedDetail'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getPublishedList()
      }
      this.socialInsuranceDialogVisible = val
    }
  },
  methods: {
    // 获取列表数据（实际项目中实现）
    getPublishedList() {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize,
      }
      if (this.searchForm.cityCode && this.searchForm.cityCode.length) {
        params.cityCode = this.searchForm.cityCode[1]
      }
      socialInsurancePolicyApi.getPublishedSocialInsurancePolicy(params).then(res => {
        this.loading = false
        // 实际项目中应该调用API获取数据，这里模拟筛选逻辑
        this.tableData = res.records || []
        // 模拟分页
        this.total = res.totalCount

      })
    },

    // 搜索功能
    handleSearch() {
      this.currentPage = 1
      this.getPublishedList()
    },

    // 重置筛选条件
    handleReset() {
      this.searchForm = {
        condition: '',
        keyword: ''
      }
      this.currentPage = 1
      this.getPublishedList()
    },

    // 页面切换
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPublishedList()
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getPublishedList()
    },

    // 行点击事件
    handleRowClick(row) {
      this.handleViewDetail(row)
    },

    // 查看详情
    handleViewDetail(row) {
      this.id = row.id
      this.detailDialog = true
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
// 移除不匹配的.social-insurance-standard类，直接使用样式
.search-container {
  margin-bottom: 20px;

  .search-form {
    display: flex;
    align-items: center;

    .el-form-item {
      margin-right: 15px;

      .el-form-item__label {
        white-space: nowrap;
      }
    }
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.insurance-type {
  color: #606266;
}

.view-btn {
  color: #409eff;

  &:hover {
    color: #66b1ff;
  }
}

:deep(.el-table) {
  .el-table__header-wrapper th {
    background-color: #f5f7fa;
    font-weight: 600;
  }

  .el-table__body {
    .el-table__row {
      cursor: pointer;

      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}

// 详情弹窗样式
.detail-content {
  .detail-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;

    h3 {
      margin: 0 0 10px 0;
      color: #303133;
    }

    .publish-time {
      color: #909399;
      margin: 0;
    }
  }

  .detail-section {
    margin-bottom: 20px;

    h4 {
      margin: 0 0 15px 0;
      color: #606266;
      font-weight: 600;
    }

    .insurance-list {
      .insurance-item {
        margin-bottom: 8px;
        padding: 8px 12px;
        background-color: #f5f7fa;
        border-radius: 4px;
        color: #606266;
      }
    }

    .policy-desc {
      line-height: 1.8;
      color: #606266;
    }
  }
}
</style>
